module.exports = __webpack_public_path__ + "static/media/onyka_barrett.2fc071b7.pdf";